module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "i304"
    }
  }), _c('a', {
    attrs: {
      "id": "i330"
    }
  }), _c('a', {
    attrs: {
      "id": "i353"
    }
  }), _c('a', {
    attrs: {
      "id": "i532"
    }
  }), _c('a', {
    attrs: {
      "id": "i570"
    }
  }), _c('a', {
    attrs: {
      "id": "i671"
    }
  }), _c('a', {
    attrs: {
      "id": "i905"
    }
  }), _c('a', {
    attrs: {
      "id": "i1607"
    }
  }), _c('a', {
    attrs: {
      "id": "i1660"
    }
  }), _c('a', {
    attrs: {
      "id": "i1670"
    }
  }), _c('a', {
    attrs: {
      "id": "i2444"
    }
  }), _c('a', {
    attrs: {
      "id": "i2456"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-35"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "chap2"
  }, [_vm._v("CHAPTER 3")]), _vm._v(" "), _c('h4', {
    staticClass: "sect1"
  }, [_vm._v("September 1979")]), _vm._v(" "), _c('p', {
    staticClass: "noindentk"
  }, [_vm._v("It hadn’t been that long ago, the warm autumn evening when a thirteen-year-old girl named Sheri Nastasia disappeared in Springfield, Vermont.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That was only five years before the summer when the names of Bernice "), _c('a', {
    attrs: {
      "id": "i635"
    }
  }), _vm._v("Courtemanche and Ellen "), _c('a', {
    attrs: {
      "id": "i876"
    }
  }), _vm._v("Fried were thrust into the consciousness of the Connecticut Valley. But the Valley had seemed like a very different place then.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To be sure, the changes had started, were well under way in fact, and already they had gone a long distance toward altering the character of this narrow fifty-mile strip of land running north and south along both sides of the Connecticut River. But there is always a period between the time when things change and the time when people recognize the new reality and begin adjusting to it. In that sense, most people in the Connecticut Valley were still living in the past.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The two states that faced each other across the river here in its upper reaches ordinarily lived more intimately with history than most American places. New Hampshire and Vermont were states whose past was tightly intertwined with the nation’s origins. Their present, because they were situated at a slight remove from the most dynamic centers of American change, had not so overwhelmed memory as in many places to the south. Tiny graveyards dotting the landscape, winding country roads that traced their origins to early cart roads and footpaths, austere old houses with narrow windows, the kind of small farms that were disappearing from much of the rest of the country, all these things were daily reminders that this "), _c('a', {
    attrs: {
      "id": "i1631"
    }
  }), _vm._v("northern edge of New England bore much of the past in its living heart.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From the start these two small states had rested physically and politically at the edge of the new nation, New Hampshire defining itself in relation, and opposition, to "), _c('a', {
    attrs: {
      "id": "i1334"
    }
  }), _vm._v("Massachusetts at its southern border, Vermont"), _c('a', {
    attrs: {
      "id": "i504"
    }
  }), _c('a', {
    attrs: {
      "id": "i516"
    }
  }), _c('a', {
    attrs: {
      "id": "i533"
    }
  }), _c('a', {
    attrs: {
      "id": "i565"
    }
  }), _c('a', {
    attrs: {
      "id": "i582"
    }
  }), _c('a', {
    attrs: {
      "id": "i1028"
    }
  }), _c('a', {
    attrs: {
      "id": "i1648"
    }
  }), _c('a', {
    attrs: {
      "id": "i1665"
    }
  }), _c('a', {
    attrs: {
      "id": "i1669"
    }
  }), _c('a', {
    attrs: {
      "id": "i1695"
    }
  }), _c('a', {
    attrs: {
      "id": "i1749"
    }
  }), _c('a', {
    attrs: {
      "id": "i2052"
    }
  }), _c('a', {
    attrs: {
      "id": "i2289"
    }
  }), _c('a', {
    attrs: {
      "id": "i2434"
    }
  }), _c('a', {
    attrs: {
      "id": "i2445"
    }
  }), _c('a', {
    attrs: {
      "id": "i2446"
    }
  }), _c('a', {
    attrs: {
      "id": "i2454"
    }
  }), _c('a', {
    attrs: {
      "id": "i2507"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-36"
    }
  }), _vm._v(" moving in the wake of New York to the west. And in between, the rows of "), _c('a', {
    attrs: {
      "id": "i528"
    }
  }), _vm._v("towns facing the Connecticut River from opposite banks often felt more social and economic affinity to each other than to the states at their backs. The first "), _c('a', {
    attrs: {
      "id": "i1699"
    }
  }), _c('a', {
    attrs: {
      "id": "i2484"
    }
  }), _vm._v("towns in what later became Vermont were originally established in the middle of the eighteenth century by the government of New Hampshire, and in 1781 a clutch of towns on the east bank of the river came close to pulling out of New Hampshire and joining up with Vermont. There was even some sentiment for carving out a new state in the Valley, within the natural boundaries of Vermont’s Green Mountains to the west and the Sunapee and Monadnock ranges in New Hampshire on the east.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the end things remained as they had been, the border between the two states running down the west bank of the river, but the sense that the Valley was a place apart remained palpable two centuries later. Identity flowed easily back and forth across the river, over the privately owned wooden bridge with the twenty-five-cent toll between Charlestown and Springfield, and across the big steel-arch bridge on the interstate highway up north from Lebanon to White River Junction, conveying more sense of movement than of change. The Valley had a newspaper that assumed its name and called itself the "), _c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "id": "i2422"
    }
  }), _vm._v("Valley News, ")]), _vm._v("refusing to choose sides; a museum that took a piece from the name of each state and called itself Montshire; and a school district, reputedly the only one in the nation, that served students in two states.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Well beyond the middle of the twentieth century the Valley remained a place of small farms and modest factories. The sheep that once supplied the nation’s wool had given way to dairy cows, and the textile mills and shoe factories that took their power from the abundant flowing water had largely been replaced by small machine shops and manufacturing plants, but the "), _c('a', {
    attrs: {
      "id": "i542"
    }
  }), _vm._v("character of the place still owed more to the early decades of the century than it did to the years of rapid change since World War II.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All that began to change for good with the coming of the interstate "), _c('a', {
    attrs: {
      "id": "i557"
    }
  }), _vm._v("highways. Beginning in the late 1950s the four-lane divided highways began pushing up from Boston into New Hampshire, northward first to Concord, the capital, then westward over 1-89 across half the state to the Connecticut River and into Vermont. From western "), _c('a', {
    attrs: {
      "id": "i1335"
    }
  }), _vm._v("Massachusetts 1-91 flowed due north along the Vermont bank of the Connecticut River, forming a strong new spine for the Valley, crossing 1-89 at White River Junction. By 1970 the last links were in place, measurably shortening the passage between north and south, opening the way for a historic migration."), _c('a', {
    attrs: {
      "id": "i364"
    }
  }), _c('a', {
    attrs: {
      "id": "i534"
    }
  }), _c('a', {
    attrs: {
      "id": "i566"
    }
  }), _c('a', {
    attrs: {
      "id": "i599"
    }
  }), _c('a', {
    attrs: {
      "id": "i993"
    }
  }), _c('a', {
    attrs: {
      "id": "i1613"
    }
  }), _c('a', {
    attrs: {
      "id": "i1615"
    }
  }), _c('a', {
    attrs: {
      "id": "i1655"
    }
  }), _c('a', {
    attrs: {
      "id": "i1668"
    }
  }), _c('a', {
    attrs: {
      "id": "i1750"
    }
  }), _c('a', {
    attrs: {
      "id": "i1949"
    }
  }), _c('a', {
    attrs: {
      "id": "i2302"
    }
  }), _c('a', {
    attrs: {
      "id": "i2437"
    }
  }), _c('a', {
    attrs: {
      "id": "i2452"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-37"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even before the last segments of the new roads were complete, people from other places—flatlanders, the old hill Yankees liked to call them—were following them northward, coming to ski or to look at the autumn leaves or just to escape for a while the growing pressures of their cities and suburbs. And, slowly at first, then with gathering momentum, they came to stay.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Through the 1960s and 1970s they came, fleeing "), _c('a', {
    attrs: {
      "id": "i1336"
    }
  }), _vm._v("Massachusetts and New York, fleeing cities and high taxes, fleeing crowding and crime and schools that were becoming like prisons, fleeing the sense that everything, that life itself, was disintegrating. In Vermont and New Hampshire they found a green and gentle land, small communities with enduring connections among their people, a kind of safety and simplicity that had seemed lost forever to the larger places from which they had come. And the "), _c('a', {
    attrs: {
      "id": "i558"
    }
  }), _vm._v("highways gave them continuing access to the things—relatives, work, the urban amenities—they had left behind.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The "), _c('a', {
    attrs: {
      "id": "i586"
    }
  }), _c('a', {
    attrs: {
      "id": "i1676"
    }
  }), _c('a', {
    attrs: {
      "id": "i2460"
    }
  }), _vm._v("population of New Hampshire grew by more than half between 1960 and 1980, Vermont’s by almost a third. In the Connecticut River Valley, still remote even with the greater ease of travel, the effects of the influx were muted. Even so, the population of the two dozen towns and two small cities between Hanover, New Hampshire, and Brattleboro, Vermont, grew by more than 20 percent in the two decades.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But there was irony in this great flow of migrants. Their numbers, their ways, their very newness began relentlessly to subvert much of what they had come to find. Their housing developments and condominiums became blemishes on the bucolic rural scene, their demand for services drove up tax rates, their separateness undermined community, and their numbers overwhelmed intimacy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the invasion of population and capital took hold it changed the very shape of the Valley. It was as if the vitality was draining slowly from the centers of the towns and small cities onto the roads radiating away from them, roads that connected them with the highways, then the interstates, and with other places. There was a new restlessness here, a need for something more than the settled, familiar life of the town, an urge to be moving, going somewhere else. Increasingly the people of the Valley, like much of the rest of America, were taking to the road, for work, for social life, for recreation. The center could not hold them.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentk"
  }, [_vm._v("Sheri Nastasia was one of those who had seemed to spin away from the old settled orbits of life in the small valley towns. Her parents were divorced, and at first Sheri and her eleven-year-old brother had lived with their mother in Florida. In July of 1979 they moved up to Springfield,"), _c('a', {
    attrs: {
      "id": "i318"
    }
  }), _c('a', {
    attrs: {
      "id": "i984"
    }
  }), _c('a', {
    attrs: {
      "id": "i1614"
    }
  }), _c('a', {
    attrs: {
      "id": "i2303"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-38"
    }
  }), _vm._v(" Vermont, just a dozen miles south of Claremont, to live with their father. John "), _c('a', {
    attrs: {
      "id": "i1602"
    }
  }), _vm._v("Nastasia was a truck driver for an oil company. Most days he was on the road. He tried to arrange for baby-sitters or asked a neighbor to keep an eye on the children, but most of the time they seemed to run free. Police officers soon became accustomed to seeing Sheri on the streets long past dark, often with her little brother in tow. At first the children’s idea of fun was ice cream and soda and the "), _c('a', {
    attrs: {
      "id": "i1616"
    }
  }), _vm._v("freedom of the streets at a time when most kids their age were being tucked in bed. The month they moved to Vermont, Sheri turned thirteen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With a population of just over ten thousand, Springfield was one of the larger places in the Valley. A little concentration of machine-tool plants had given it one of the steadiest economies in the Valley, too, but by 1979 foreign competition was undermining its strength. Over the next ten years it would be one of the few places in the Valley to lose population.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Though it was a town, governed by a board of selectmen, Springfield was distinct from the smaller places in the Valley, where life and activity were more private, less visible. Springfield looked like a small city. Its business was visible on the street, condensed into the space of a few blocks. The town center held a motley mixture of plain three-story office buildings, their street-level fronts opened up to make display windows for stores, an occasional wood-frame structure with professional offices, and a few brick buildings that looked as if they could once have been the homes of wealthy families. Now they had been converted to accommodate businesses.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the center of town, crowded into the midst of the commercial life along Main Street, stood the First Congregational Church, an impressive building with six two-story fluted columns in front and a steeple rising to a high gold mast. Many days, at the edge of the sidewalk in front of the building, a blackboard issued an invitation: “Senior Citizens—Today’s Menu: Liver and Onions, Tomatoes Stewed, Boiled Potatoes.” Lunch was three dollars, but for those over sixty, a donation was optional.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That was the surface of daily life in Springfield, but just beneath it there was an undercurrent of something darker, flowing from the center of town out to the little shopping plaza, a distance of less than a mile, then back to the center, restless, searching.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Daylight rendered them less visible, but after dark there was a constant traffic here of people with nothing much to do, nowhere else to go, no one to go home to. Among them there were those known to the police as drifters and minor drug dealers, drinkers and brawlers and loiterers,"), _c('a', {
    attrs: {
      "id": "i232"
    }
  }), _c('a', {
    attrs: {
      "id": "i1360"
    }
  }), _c('a', {
    attrs: {
      "id": "i1386"
    }
  }), _c('a', {
    attrs: {
      "id": "i1608"
    }
  }), _c('a', {
    attrs: {
      "id": "i1617"
    }
  }), _c('a', {
    attrs: {
      "id": "i1904"
    }
  }), _c('a', {
    attrs: {
      "id": "i2318"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-39"
    }
  }), _vm._v(" a kind of small-city street furniture. And there were those who were drawn to them, lured by the sense of movement and action: teenagers driving too fast and making too much noise, young men looking for drugs, the occasional women looking for diversion or maybe a little cash, older men looking for the women.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And among them, before long, was Sheri Nastasia, often wearing brief shorts and a halter top, with her long, dark blond hair hanging down her back, a thirteen-year-old girl who looked older, old enough to drift along with this human current, certainly too old to be thrilled by ice cream and soda and the chance to stay up late.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On a warm Tuesday night in late August, an ordinary late-summer night, Sheri Nastasia went out as usual. And as usual, she had no particular destination. She never came home.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She was reported missing the next day and the local police began an investigation. Lots of Springfield police officers were familiar with Sheri Nastasia. There were places that cops walking the street or riding in a patrol car kept an eye on without thinking about it, certain houses where there had been trouble, shadowed areas behind buildings, an alley outside a bar where knots of people formed and dissolved through the night. Sheri Nastasia had been turning up in those places all summer. Beat cops and detectives talked to the people who hung around there, the men and women who moved routinely along the strip between the center of town and the shopping plaza. They all knew Sheri Nastasia, and they all had noticed her around in the last day or two, especially the men. But no one had an idea where she could have gone. Or at least no one had an idea they were willing to talk about. Even at the best of times there was something furtive about these people, something guarded. Now, when there was some mystery, a question of what might have happened, a possibility of trouble on the street, they seemed to draw back into themselves, pulling shades, drawing curtains, closing doors as they went.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A detective soon found a man with a room in the same house as the "), _c('a', {
    attrs: {
      "id": "i1625"
    }
  }), _vm._v("Nastasias who said he had seen Sheri walking along River Street about midnight on Tuesday. A dark car, maybe green, he thought it looked like a Pontiac Firebird, slowed to match her pace, then followed alongside as she continued walking. After a few moments the car stopped and Sheri got in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That was the only solid lead that turned up. The investigators did what they could with it, checking out a number of people with criminal records, some that involved sex crimes and young girls. They turned up at least one case where a possible suspect owned a Firebird. None of"), _c('a', {
    attrs: {
      "id": "i311"
    }
  }), _c('a', {
    attrs: {
      "id": "i1472"
    }
  }), _c('a', {
    attrs: {
      "id": "i1507"
    }
  }), _c('a', {
    attrs: {
      "id": "i1609"
    }
  }), _c('a', {
    attrs: {
      "id": "i1623"
    }
  }), _c('a', {
    attrs: {
      "id": "i1794"
    }
  }), _c('a', {
    attrs: {
      "id": "i2304"
    }
  }), _c('a', {
    attrs: {
      "id": "i2405"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-40"
    }
  }), _vm._v(" these efforts produced anything useful. There were reports that Sheri had run away from home before, mad at her father, mad at limits, mad at life, returning several days later. In the absence of any evidence to the contrary, it seemed likely that she had just decided to take off on her own again. Most people thought that she’d probably turn up soon, the way these teenagers did, seeming a little surprised that anybody had noticed she was gone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They were wrong. Three and a half months later, a truck driver taking a break at a rest area on Route 103, ten miles south of Springfield, found a body. Time and exposure had reduced the remains to little more than bones.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was snowing when the driver made his discovery. The local police soon arrived, sealed off the site and the surrounding ground, and put in a call for the mobile crime lab from the state authorities. By the time the technicians arrived and prepared to go to work the area was covered with snow. It was a laborious process, trying to clear away the snow and examine everything minutely for any tiny trace of evidence. They didn’t come up with much beside the skeleton.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The bones and teeth provided enough evidence to allow a positive identification. It was Sheri Nastasia.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Apart from the identification, the investigators didn’t have much to work with. The condition of the body made it impossible even to be sure about what had killed Sheri Nastasia. The investigators were proceeding on the assumption that she had been abducted and killed, but strictly speaking there was insufficient evidence for an official ruling that the cause of death was homicide. She had suffered broken ribs and a broken leg. If she had been murdered, the medical examiner concluded, it had probably been done by strangulation, but that was the most that could be said. The hyoid bone, the one in the neck that would probably show if she had been strangled, was missing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As for finding the person responsible, the problem was the opposite of the one the police usually faced, where they could subject a limited number of potential suspects to close scrutiny. Here there were too many suspects. All the rough inhabitants of the dim downtown corners, all the careless thrill-seekers who were drawn to them, any of them could have done this. One after another, the police checked them out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One detective was amazed at how many of the suspects failed polygraph examinations, the so-called lie detector test, men who later proved to have solid alibis.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The detective came to the conclusion that the people of the streets had an abundance of things to feel guilty about, things that could produce"), _c('a', {
    attrs: {
      "id": "i262"
    }
  }), _c('a', {
    attrs: {
      "id": "i322"
    }
  }), _c('a', {
    attrs: {
      "id": "i1746"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-41"
    }
  }), _vm._v(" the fugitive perspiration, the skittering pulse, that gave them away to the polygraph operator. Maybe they had played at sex with this underage girl, or had tried to, or just wanted to, or knew somebody who had, or maybe they had provided this child and her brother with beer or drugs. There were certainly crimes here, but none of them involved the "), _c('a', {
    attrs: {
      "id": "i1610"
    }
  }), _vm._v("disappearance of Sheri Nastasia. Even the sighting of Sheri getting into the car had led to a dead end. Other than that, no one had seen a thing, no one had an idea.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From an investigator’s point of view, the case was a disaster.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Everything that could have gone wrong went wrong, right from the beginning of that case,” one of the detectives recalled later. From the snow that interfered with the gathering of evidence to the lack of leads and solid suspects, nothing seemed to favor the investigators. Over the next several months, in spite of intense activity, it turned into the kind of investigation where the police never felt they were close to the truth about what had happened and who was responsible. And then, as more months passed and the first anniversary of Sheri Nastasia’s disappearance approached, it began to seem that the case would never be solved without some kind of surprising break.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was two years before the death of Sheri Nastasia returned to force its way again into public consciousness.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9599019a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Chapter_03.vue
// module id = 93
// module chunks = 0